<h3 mat-dialog-title>{{ _fileUpload.title }}</h3>
<div mat-dialog-content style="width: 100%">
    <p>
        Faça um upload de um arquivo XLS, no formato do arquivo modelo. <br>
        <a href="{{utiliesService.server + _fileUpload.urlArchiveModule}}">Faça download do arquivo modelo.</a>
        <br>
        <b>OBS.: Siga o modelo em anexo, mas, adicione apenas as linhas com o conteúdo que será importado.</b>
    </p>

    <input 
        hidden 
        type="file" 
        #fileInput 
        (change)="uploadFile($event)" 
        ng2FileSelect 
        [uploader]="uploader" 
        [(ngModel)]="hasFile"
        [accept]="['.xls','.xlsx']"
    />
    
    <button 
        mat-button 
        (click)="fileInput.click()" 
        tabindex="-1" 
        [disabled]="uploader.queue.length > 0" 
    >
        <mat-icon>cloud_upload</mat-icon>
        Clique aqui e selecione o arquivo
    </button>

    <p *ngFor="let item of uploader.queue">
        <b>{{nomeFile}}</b> 
        <button 
            type="button" 
            mat-button 
            tabindex="-1" 
            (click)="item.remove()"
        >
            X
        </button>
    </p>
</div>
<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >   
        Cancelar
    </button>
    <button 
        type="button"
        mat-button
        [disabled]="isInvalidForm()" 
        (click)="startUpload()"
        tabindex="-1" >
        Enviar
    </button>
</div>
